/* eslint-disable no-nested-ternary */
/** no-unused-expressions */
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { genericFormatAmount } from '@panel/commons/helpers/formatAmount';
import { useTranslation } from 'react-i18next';
import { selectColor, ModalBase, sendTrackingInfo } from '@panel/commons';
import { useDispatch } from 'react-redux';
import { select } from '@panel/commons/core/themev2';
import AlertIcon from '@panel/commons/assets/icons/AlertNotify.svg';
import AlertIconGrey from '@panel/commons/assets/icons/AlertTriangleGrey.svg';
import ReportsModal from '@panel/commons/lib/Modals/ReportsModal';
import { PostingsOperations } from '../../../../ducks/posting';
import { ReservationOperations } from '../../../../ducks/reservation';
import { StatusTag } from './styles';
import { Modal } from '../../Modals/ModalWrapper';
import DropDown from './DropDown';
import QualityArea from '../../PostingsListDesktop/Posting/QualityArea';

function DetailHeader({
  priceAndOperation,
  propertyType,
  status,
  title,
  address,
  city,
  totalReport,
  isReservado,
  postingId,
  postingReports,
  linkToEdit,
  quality,
  qualityNotApply,
  isDuplicate,
  isPenalized,
  qualityStatus,
  validations,
  openModal,
  isIntegrator,
  isAssistant,
  isParticular
}) {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const { checkReport, fetchReports } = PostingsOperations;
  const { savePostingTag } = ReservationOperations;

  const redirectToEdit = () => {
    window.location = linkToEdit;
  };

  const getFormatedPrices = () => {
    const prices = [];
    priceAndOperation.forEach(operation => {
      if (operation) {
        const { amountAndCurrency } = operation;
        prices.push({
          operationType: t(`panel.postings.operations.operationType.${operation.operationType}`),
          price:
            amountAndCurrency && amountAndCurrency[0].amount > 0
              ? genericFormatAmount(amountAndCurrency[0].amount, amountAndCurrency[0].currency)
              : t('postings.card.price.withoutPrice'),
          secondPrice:
            amountAndCurrency && amountAndCurrency[1]
              ? genericFormatAmount(amountAndCurrency[1].amount, amountAndCurrency[1].currency)
              : ''
        });
      }
    });
    return prices;
  };

  const priceList = getFormatedPrices();

  const processReports = () => {
    if (!postingReports) return;
    const { reports } = postingReports;
    let countNew = 0;
    let countChecked = 0;
    if (!reports) return;
    reports.forEach(rep => {
      countChecked += rep.checked;
      countNew += rep.unChecked;
    });
    // eslint-disable-next-line consistent-return
    return { countNew, countChecked };
  };

  const processedReportCounts = processReports();

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const getQualityText = () => {
    if (qualityNotApply) return 'notApply';
    if (isDuplicate) return 'duplicated';
    if (isPenalized) return 'penalized';
    if (quality >= 0 && !qualityNotApply) return 'ok';
    return 'withoutData';
  };

  const getQualityMessage = () => {
    if (isDuplicate) return 'panel.avisos.posting.quality.duplicated';
    if (isPenalized) return 'panel.avisos.posting.quality.penalized';
    return `panel.posting.quality.${!qualityNotApply && qualityStatus ? qualityStatus : 'not_apply'}`;
  };

  return (
    <ContentLayout noPrice={priceList.length === 0}>
      {showModal && (
        <Modal>
          <ModalBase openModal={showModal} onClose={() => setShowModal(false)} width='328px' height='fit-content'>
            <ReportsModal
              onClose={() => setShowModal(false)}
              device='mobile'
              isReserved={isReservado}
              postingReports={postingReports}
              redirectToEdit={redirectToEdit}
              isIntegrator={isIntegrator}
              hasReportsUnchecked={processedReportCounts && processedReportCounts.countNew}
              checkReport={() => dispatch(checkReport(postingId))}
              fetchReports={() => dispatch(fetchReports(postingId))}
              savePostingTag={() => dispatch(savePostingTag(postingId, 1))}
              isAssistant={isAssistant}
            />
          </ModalBase>
        </Modal>
      )}
      <div className='operation-header'>
        <OperationInfo data-panel='posting-realEstateType'>{propertyType}</OperationInfo>
        <StatusTag data-panel='posting-stateLabel' type={status}>
          <div />
          {t(`panel.posting.status.${status}`)}
        </StatusTag>
      </div>
      <h3 className='title-header' data-panel='posting-title'>
        {title && title !== 'GENERIC_TITLE' ? title : t('postings.card.info.withoutTitle')}
      </h3>
      <div className='address' data-panel='posting-address'>
        {address ? `${address}${city ? `, ${city}` : ''}` : t('postings.card.info.withoutAddress')}
      </div>
      {totalReport > 0 && (
        <ReportContainer hasUncheckedReport={processedReportCounts.countNew}>
          <div>
            <Alert hasUncheckedReport={processedReportCounts.countNew} />
            {!processedReportCounts.countNew ? (
              <TextContainer>
                <ReportMessage>
                  {t('panel.avisos.report.message')} {<b>{totalReport}</b>}{' '}
                  {t(`panel.avisos.report.message.end${totalReport > 1 ? '.plural' : ''}`)}
                </ReportMessage>
              </TextContainer>
            ) : (
              <TextContainer>
                {t('panel.avisos.report.new.message')}
                {
                  <b>
                    {processedReportCounts.countNew}{' '}
                    {t(`panel.avisos.report.new.message.end${processedReportCounts.countNew > 1 ? '.plural' : ''}`)}
                  </b>
                }
              </TextContainer>
            )}
          </div>
          <ReportButton
            onClick={() => {
              setShowModal(true);
              sendTrackingInfo('Panel', 'Mis avisos', `Card del aviso-Ver reportes`);
            }}
          >
            {t(`panel.avisos.report.message.see${totalReport > 1 ? '.plural' : ''}`)}
          </ReportButton>
        </ReportContainer>
      )}
      <div className='mount'>
        {priceList &&
          priceList.map(item => {
            return (
              <PriceContainer key={item.operationType}>
                <div className='price-operation' data-panel={`posting-priceInfo-${item.operationType}`}>
                  {item.operationType}
                </div>
                <div className='price-amount' data-panel={`posting-priceInfo-${item.operationType}-price`}>
                  {`${item.price}${item.secondPrice ? ` / ${item.secondPrice}` : ''}`}
                </div>
              </PriceContainer>
            );
          })}
      </div>
      <DropDown
        isOpen={dropdownOpen}
        setIsOpen={setDropdownOpen}
        title={t('panel.avisos.posting.card.quality.title')}
        height={300}
      >
        <QualityContainer>
          <QualityArea
            quality={quality}
            qualityNotApply={qualityNotApply}
            device='mobile'
            isDuplicate={isDuplicate}
            isPenalized={isPenalized}
            qualityStatus={qualityStatus}
            usedForTour={false}
            validations={validations}
            openModal={openModal}
            tooltipText={
              qualityNotApply ? t('panel.avisos.posting.tooltip.withoutData', { postingType: propertyType }) : ''
            }
            qualityText={t(`panel.avisos.posting.quality.${getQualityText()}`)}
          />
          <QualityRight
            qualityStatus={qualityStatus}
            hasTips={validations && validations.length > 0}
            postingComplete={quality === 100}
          >
            <div data-panel='posting-qualityLevel'>
              {qualityStatus === 'not_apply'
                ? t('panel.avisos.posting.tooltip.withoutData', { postingType: propertyType })
                : t(getQualityMessage())}
            </div>
            {qualityStatus !== 'not_apply' && (
              <div
                className='quality-status-link'
                disabled={!validations || validations.length === 0}
                onClick={e => {
                  if (validations && validations.length > 0 && quality < 100) {
                    // eslint-disable-next-line no-unused-expressions
                    openModal(e);
                    sendTrackingInfo('Panel', 'Mis avisos', 'Card del aviso-Completitud del aviso');
                  }
                }}
              >
                {quality < 100 ? t('panel.avisos.posting.calidad.mejora') : t('panel.avisos.posting.tooltip.complete')}
              </div>
            )}
          </QualityRight>
        </QualityContainer>
      </DropDown>
    </ContentLayout>
  );
}

const ContentLayout = styled.div`
  position: relative;
  box-shadow: 0px 3px 8px rgba(93, 115, 126, 0.1);
  padding-bottom: 20px;
  > div,
  h3 {
    padding: 0 16px;
  }
  .operation-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .title-header {
    margin: 8px 0;
    font-size: 16px;
    font-family: Hind;
    font-size: 20px;
    font-weight: 600;
    line-height: 26px;
    white-space: break-spaces;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .address {
    font-family: Hind;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    margin-bottom: 24px;
    color: ${selectColor('grayDark')};
    white-space: break-spaces;
    text-overflow: ellipsis;
    overflow: hidden;
    ${({ noPrice }) =>
      noPrice &&
      css`
        border-bottom: 1px solid ${selectColor('grayMediumLight')};
        padding: 0;
        margin-left: 16px;
        margin-right: 16px;
      `};
  }
  .mount {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
`;

const OperationInfo = styled.div`
  color: ${selectColor('grayDark')};
  font-size: 14px;
  display: flex;
  align-items: center;
  min-height: 16px;
  font-weight: 600;
`;

const ReportContainer = styled.div`
  display: flex;
  align-items: center;
  max-width: 100%;
  justify-content: space-between;
  background-color: ${({ hasUncheckedReport }) => select(hasUncheckedReport ? 'redBack' : 'grayMedium')};
  border-radius: 4px;
  min-height: 43px;
  padding: 0 11px 0 9px;
  color: ${({ hasUncheckedReport }) => select(hasUncheckedReport ? 'negative' : 'grayDark')};
  border-left: 4px solid ${({ hasUncheckedReport }) => select(hasUncheckedReport ? 'negative' : 'grayDark')};
  margin-bottom: 25px;
  margin-left: 16px;
  margin-right: 16px;
  > div {
    display: flex;
    align-items: center;
  }
`;

const TextContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  > b {
    margin-left: 4px;
  }
`;

const Alert = styled.div`
  background-image: ${({ hasUncheckedReport }) => `url(${hasUncheckedReport ? AlertIcon : AlertIconGrey})`};
  background-size: contain;
  background-repeat: no-repeat;
  width: 15px;
  height: 15px;
  margin-right: 8px;
`;

const ReportButton = styled.button`
  font-weight: 600;
  cursor: pointer;
`;

const ReportMessage = styled.div`
  font-family: Hind;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`;

const PriceContainer = styled.div`
  margin-bottom: 8px;
  :last-of-type {
    margin-bottom: 25px;
  }
  .price-operation {
    font-family: Hind;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    color: ${selectColor('grayDark')};
    display: inline;
    margin-right: 8px;
  }
  .price-amount {
    font-size: 18px;
    font-weight: 600;
    display: inline;
  }
`;

const QualityContainer = styled.div`
  width: 100%;
  padding: 0 16px;
  height: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const QualityColors = {
  ok: select('positive'),
  warn: select('yellow'),
  error: select('negative'),
  not_apply: select('midDarkGray')
};

const QualityRight = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 40px;
  max-width: 60%;
  > div {
    font-family: Hind;
    white-space: break-spaces;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 23px;
    letter-spacing: 0em;
    color: ${({ qualityStatus }) => QualityColors[qualityStatus]};
    &.quality-status-link {
      font-family: Hind;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 18px;
      letter-spacing: 0em;
      color: ${({ qualityStatus, hasTips, postingComplete }) =>
        qualityStatus === 'not_apply' || !hasTips || postingComplete ? select('midLightGray') : 'black'};
      text-decoration: ${({ postingComplete }) => !postingComplete && 'underline'};
      margin-top: 6px;
      cursor: pointer;
    }
  }
`;

export default DetailHeader;
